export const organizationState = {
    organizationName: "",
    organizationNumber: "",
    organizationPhoneNumber: "",
    organizationAddress: "",
    pinCode: "",
    city: "",
    state: "",
    country:"",
    isLoading: false,
    Message: ""
}
